import HeroSection from "@/components/HeroSection";
import Services from "@/components/Services";
import Branches from "@/components/Branches";
import ContactForm from "@/components/ContactForm";
import Portfolio from "@/components/Portfolio";
import Clients from "@/components/Clients";

const Home = () => {
  return (
    <>
      <HeroSection />
      <Services />

      {/* Portfolio Section */}
      <section id="work" className="py-32 relative">
        <div className="absolute top-0 w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
        <div className="container relative z-10">
          <div className="text-center mb-20">
            <span className="text-primary font-bold tracking-widest uppercase text-sm mb-4 block">Portfolio</span>
            <h2 className="text-5xl md:text-7xl font-black mb-6">RECENT WORK</h2>
            <p className="text-text-muted max-w-2xl mx-auto text-xl">
              Explore some of our latest projects and success stories.
            </p>
          </div>
          <Portfolio />
        </div>
      </section>

      {/* Clients Carousel */}
      <Clients />

      <Branches />
      <ContactForm />
    </>
  );
};

export default Home;
